import { Text } from '@thanx/uikit/text'
import Section from 'components/Section'
import { buildTranslate } from 'locales'
import React from 'react'
import { ContentBlockData } from 'slices/appLandingPageTheme/types'
import ContentBadges from './ContentBadges'
import ExternalFormContent from './ExternalFormContent'
import FeaturedContent from './FeaturedContent'
import FeaturedContentCarouselContent from './FeaturedContentCarouselContent'
import GameContent from './GameContent'
import HelpLinkSection from './HelpLinkSection'
import PersonalizedTextContent from './PersonalizedTextContent'

const t = buildTranslate('cms.content.app_home_page.content.edit_block.content')

type Props = {
  blockId: string
  contentBlock: ContentBlockData
}

const Content = ({ blockId, contentBlock }: Props) => {
  const { type } = contentBlock

  const renderContent = () => {
    switch (type) {
      case 'featured_content':
        return <FeaturedContent blockId={blockId} contentBlock={contentBlock} />
      case 'external_form':
        return (
          <ExternalFormContent blockId={blockId} contentBlock={contentBlock} />
        )
      case 'personalized_text':
        return (
          <PersonalizedTextContent
            blockId={blockId}
            contentBlock={contentBlock}
          />
        )
      case 'featured_content_carousel':
        return (
          <FeaturedContentCarouselContent
            blockId={blockId}
            contentBlock={contentBlock}
          />
        )
      case 'game':
        return <GameContent blockId={blockId} contentBlock={contentBlock} />
      default:
        return <></>
    }
  }

  return (
    <div className="d-flex flex-column">
      <Text.Header3>{t('title')}</Text.Header3>
      <ContentBadges type={type} />
      <Section className="flex-1 mb-l mr-xs p-l">{renderContent()}</Section>
      <HelpLinkSection type={contentBlock.type} />
    </div>
  )
}

export default Content
